

























































































































































import BillingProduct from '@/datatypes/billing/product';
import BillingPrice from '@/datatypes/billing/price';
import BillingProductService from '@/services/billing/BillingProductService';
import BillingPriceService from '@/services/billing/BillingPriceService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import BillingPriceCreateRequest from '@/datatypes/billing/price-create-request';
import BillingPriceMetadata from '@/components/billing/Metadata.vue';
import BillingPriceStructure from '@/components/billing/billing-price-structure.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import MoneyInput from '@/components/money.vue';

export default Vue.extend({
  data: () => ({
    billingProduct: new BillingProduct({}),
    billingPrice: new BillingPrice({
      active: true,
    }),
    billingProductService: new BillingProductService(),
    billingPriceService: new BillingPriceService(),
    errorMessage: '',
    nextPointer: undefined as undefined | string,
    usageType: undefined as undefined | string,
    licensedIntervals: {
      month: 1,
      year: 1,
    },
    isCreatingPrice: false,
  }),

  components: {
    SnackbarMessageHandler,
    MoneyInput,
    BillingPriceMetadata,
    BillingPriceStructure,
  },

  mounted() {
    this.routeChanged();
  },

  methods: {
    routeChanged() {
      this.getBillingProduct();
    },

    priceChange(value) {
      this.billingPrice.unitAmount = value;
    },

    getBillingProduct() {
      const billingProductId = this.$route.params.id;
      this.billingPrice.billingProductId = billingProductId;

      this.billingProductService.show(billingProductId).then((response) => {
        this.billingProduct = new BillingProduct(camelcaseKeysDeep(response.data));
      });
    },

    createPrice() {
      const request = new BillingPriceCreateRequest(this.billingPrice);

      this.billingPriceService.create(this.billingProduct.id, request).then((response) => {
        this.$router.push(`/billing-prices/${response.data.id}`);
      });
    },

    setLicensedInterval(interval): void {
      if (Object.keys(this.licensedIntervals).includes(interval)) {
        this.billingPrice.recurring.intervalCount = this.licensedIntervals[interval];
      }
    },
  },

  computed: {
    meteredOk(): boolean {
      return (
        (this.billingPrice.recurring.usageType === 'metered')
        && (this.billingPrice.unitAmount && (this.billingPrice.unitAmount > 0))
      ) as boolean;
    },

    licensedOk(): boolean {
      return (
        (this.billingPrice.recurring.usageType === 'licensed')
        && (this.billingPrice.unitAmount && (this.billingPrice.unitAmount > 0))
        && (
          (this.billingPrice.recurring.interval === 'month')
          || (this.billingPrice.recurring.interval === 'year')
        )
      ) as boolean;
    },

    priceComplete(): boolean {
      return (this.meteredOk || this.licensedOk) && this.billingPrice.metadata.complete();
    },
  },

  watch: {
    $route() {
      this.routeChanged();
    },
    usageType(value) {
      this.billingPrice.recurring.usageType = value;

      const currency = process.env.VUE_APP_CURRENCY;

      if (value === 'metered') {
        this.billingPrice.billingScheme = 'per_unit';
        this.billingPrice.currency = currency;
        this.billingPrice.recurring.interval = 'month';
        this.billingPrice.recurring.intervalCount = 1;
        this.billingPrice.recurring.aggregateUsage = 'last_during_period';
      } else if (value === 'licensed') {
        this.billingPrice.billingScheme = 'per_unit';
        this.billingPrice.currency = currency;
        this.billingPrice.recurring.aggregateUsage = undefined;
      }
    },
  },
});
